module.exports = __webpack_public_path__ + "static/media/mongodb.cfee114b.svg";